<mat-card>
  <mat-card-title>No está autorizado para acceder a esta página</mat-card-title>
  <mat-card-subtitle>Si cree que debería tener acceso a esta característica, debe informalo a su jefe inmediato.</mat-card-subtitle>
  <mat-card-actions align="end">
      <button mat-button (click)="navigateService.goBack()">Volver</button>
  </mat-card-actions>
</mat-card>
